var DesktopAppEvents;
(function (DesktopAppEvents) {
    DesktopAppEvents["SignOut"] = "sign-out";
    DesktopAppEvents["ToggleNotifications"] = "toggle-desktop-notifications";
})(DesktopAppEvents || (DesktopAppEvents = {}));

export { DesktopAppEvents };
